import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { useAlphaAccess } from "../../hooks/useAlphaAccess";

interface AlphaAccessGuardProps {
  children: React.ReactNode;
}

const AlphaAccessGuard: React.FC<AlphaAccessGuardProps> = ({ children }) => {
  const canAccessAlpha = useAlphaAccess();
  const { getDefaultLandingPage } = useAuth();

  if (!canAccessAlpha) {
    return <Navigate to={getDefaultLandingPage()} replace />;
  }

  return <>{children}</>;
};

export default AlphaAccessGuard;
